import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HomeEmptyState } from '../atoms/HomeEmptyState';
import { HomeLoadingState } from '../atoms/HomeLoadingState';
import { HomeSectionHeader } from '../molecules/HomeSectionHeader';
import type { ReactNode } from 'react';

interface HomeWorkQueueProps {
  title: string;
  icon: ReactNode;
  href?: string;
  onRefresh: () => void;
  refreshLabel: string;
  loading: boolean;
  loadingLabel: string;
  error: string | null;
  empty: ReactNode;
  children: ReactNode;
  hasItems: boolean;
  count?: number;
}

export const HomeWorkQueue = ({
  title,
  icon,
  href,
  onRefresh,
  refreshLabel,
  loading,
  loadingLabel,
  error,
  empty,
  children,
  hasItems,
  count,
}: HomeWorkQueueProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.section}>
      <HomeSectionHeader
        title={title}
        icon={icon}
        href={hasItems ? href : undefined}
        onRefresh={onRefresh}
        refreshLabel={refreshLabel}
        loading={loading}
        count={count}
      />
      <Box className={classes.panel}>
        {loading ? (
          <HomeLoadingState label={loadingLabel} />
        ) : error ? (
          <HomeEmptyState>{error}</HomeEmptyState>
        ) : !hasItems ? (
          empty
        ) : (
          <Box className={classes.items}>{children}</Box>
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  section: { marginBottom: theme.spacing(3) },
  panel: { minWidth: 0 },
  items: {
    display: 'grid',
    border: `1px solid ${theme.palette.border}`,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
  },
}));
